import * as ST from './styled';

const arrow_load_cards = '/static/images/full-buy/arrow_load_cards.svg';

interface ICardLoader {
    onClick: () => void,
    width: number,
}

const CardLoader = ({ onClick, width }: ICardLoader): JSX.Element => {
    return (<ST.CardWrapper onClick={onClick} width={width}>
        <ST.CardContent>
            <ST.CardCircle >
                <ST.CardArrow imgUrl={arrow_load_cards} />
            </ST.CardCircle>
            <ST.CardLabel>
                Показать все
            </ST.CardLabel>
        </ST.CardContent>
    </ST.CardWrapper>);
};

export default CardLoader;
